import React , { Component } from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import Header from './Header';
import Footer from './Footer';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading:true

    };
  }


  render() {

    let header = (this.props.header || <Header/>)
    return (
      <div>
        {header}
        <div id="main-container" className="container-fluid container-cards-pf container-pf-alt-nav-pf-vertical-alt">
          {this.props.chart}
          <Footer/>
        </div>
    </div>
    );
  }
}

App.PropTypes = {
  charts: PropTypes.Array
}

export default injectIntl(App);



// WEBPACK FOOTER //
// ./src/components/App.js